import gql from "graphql-tag"
import { useMutation } from "react-apollo"

import { DOCTOR_MESSAGE_FRAGMENT } from "graphql/queries/user"
import { ReadDoctorMessagesMutation, ReadDoctorMessagesMutationVariables } from "typings/types"

const READ_DOCTOR_MESSAGES = gql`
  mutation ReadDoctorMessages($consultationId: Int!) {
    readDoctorMessages(consultationId: $consultationId) {
      id
      unreadDoctorMessagesCount
      consultationMessages(newestFirst: true) {
        id
        ...DoctorMessageFragment
      }
    }
  }
  ${DOCTOR_MESSAGE_FRAGMENT}
`

export const useReadDoctorMessages = () =>
  useMutation<ReadDoctorMessagesMutation, ReadDoctorMessagesMutationVariables>(READ_DOCTOR_MESSAGES)
